import axiosInstance from "../api/axiosInstance";

// GET: List all Vault Questions (with pagination, filters, search)
export const fetchVaultQuestions = (params) =>
  axiosInstance.get("/admin/vaultQuestionList", { params });

// GET: Get single Vault Question by ID
export const getVaultQuestionById = (id) =>
  axiosInstance.get(`/admin/vaultQuestion/${id}`);

// POST: Add a new Vault Question
export const createVaultQuestion = (data) =>
  axiosInstance.post("/admin/vaultQuestionAdd", data);

// PUT: Update a Vault Question by ID
export const updateVaultQuestionById = (id, data) =>
  axiosInstance.put(`/admin/vaultQuestionUpdate/${id}`, data);

// PATCH: Change status (active/inactive) of a Vault Question
export const changeVaultQuestionStatus = (id, data) =>
  axiosInstance.patch(`/admin/vaultQuestionStatus/${id}`, data);

// DELETE: Soft delete a Vault Question
export const deleteVaultQuestion = (id) =>
  axiosInstance.delete(`/admin/vaultQuestionDelete/${id}`);

// PATCH: Flag a Vault Question (e.g., inappropriate/problematicContent)
export const flagVaultQuestion = (id, data) =>
  axiosInstance.patch(`/admin/vaultQuestionFlag/${id}`, data);

// GET: Track Vault Question stats (usage: views, skips, drop-offs)
export const getVaultQuestionStats = (id) =>
  axiosInstance.get(`/admin/vaultQuestionStats/${id}`);

// POST: Bulk soft delete Vault Questions
export const deleteVaultQuestionsBulk = (ids) =>
  axiosInstance.post("/admin/vaultQuestionDeleteBulk", { id: ids });

// GET : Export Vault Questions
export const exportVaultQuestions = async (params) => {
  const response = await axiosInstance.get("/admin/vaultQuestionExport", {
    params,
    responseType: "blob",
    headers: { "Content-Type": undefined }, // ⬅️ override so backend isn't confused
  });
  return response;
};

// POST : Bulk Upload Vault Questions
export const saveBulkVaultQuestionsService = async (data) => {
  return axiosInstance.post("/admin/vaultQuestion/bulk", data);
};

// GET : Bulk fetch Vault Questions by IDs
export const fetchBulkVaultQuestionsService = async (ids) => {
  return axiosInstance.get(`/admin/vaultQuestions-bulkFetch`, {
    params: { ids: ids.join(",") }, // e.g. ?ids=123,456,789
  });
};

export const aiGenerateQuestions = async (topic) => {
  const res = await axiosInstance.post("/admin/aigenerator", { topic });
  return res.data;
};

export const aiReviewQuestion = async (id) => {
  const res = await axiosInstance.post("/admin/aireview", { id });
  return res.data;
};

// Bulk AI review
export const bulkAIReview = (ids = []) => {
  return axiosInstance.post("/admin/bulkReview", { ids });
};

export const publishVaultQuestion = (id) => {
  return axiosInstance.put(`/admin/vaultQuestion/publish/${id}`);
};

export const bulkPublishVaultQuestions = (ids) => {
  return axiosInstance.put(`/admin/vaultQuestion/bulk-publish`, { ids });
};

// Human review (2026-10-07): approve = published and active in one step;
// decline = it never runs. Beside the AI review, and it overrides it.
export const reviewVaultQuestion = (id, decision, reason = "") => {
  return axiosInstance.put(`/admin/vaultQuestion/review/${id}`, { decision, reason });
};